// extracted by mini-css-extract-plugin
export default {"ViewMore":"LoadMoreWithExtendedDate_ViewMore__jVQ91","PlainText":"LoadMoreWithExtendedDate_PlainText__zbBQ9","ViewMoreText":"LoadMoreWithExtendedDate_ViewMoreText__j8wW5"};